import 'jquery-ui';
import 'jquery-ui/ui/widgets/datepicker';
import 'jquery-ui/ui/widgets/slider';


// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/jquery-ui-custom.js